var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full bg-brand-gray-100"},[_c('h2',{staticClass:"my-auto font-serif text-black font-semibold text-md my-4 mx-6"},[_c('n-html',{attrs:{"text":_vm.text}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }